<!--Todo: Aplicar estilos y embellezer -->
<div *ngIf="oferta">
    <h2>Detalles de la Oferta</h2>
    <div class="grid">

      <p><strong>Monto Aprobado:</strong> {{ oferta.montoAprobado | currency:'CLP':'symbol':'1.0-0' }}</p>
      <p><strong>Tasa de Interés Anual:</strong> {{ oferta.tasaInteresAnual }}%</p>
    <p><strong>Tasa de Interés Mensual:</strong> {{ oferta.tasaInteresMensual }}%</p>
    <p><strong>Carga Anual Equivalente:</strong> {{ oferta.cargaAnualEquivalente }}%</p>
    <p><strong>Periodo (Meses):</strong> {{ oferta.periodoMeses }} Cuotas</p>
    <p><strong>Gastos Notario:</strong> {{ oferta.gastosNotario | currency:'CLP':'symbol':'1.0-0'  }}</p>
    <p><strong>Impuestos:</strong> {{ oferta.impuestos | currency:'CLP':'symbol':'1.0-0'  }}</p>
    <p><strong>Costo Total del Crédito:</strong> {{ oferta.costoTotalCredito | currency:'CLP':'symbol':'1.0-0'  }}</p>
    <p><strong>Valor Mensual de la Cuota:</strong> {{ oferta.valorMensualCuota | currency:'CLP':'symbol':'1.0-0'  }}</p>
    <p><strong>Condiciones Generales:</strong> {{ oferta.condicionesGenerales }}</p>
  </div>
  <div class="botones">
    <button (click)="cambiarEstado('AceptadaCliente')" >Aceptar Oferta</button>
    <button (click)="cambiarEstado('NoSelecionada')">Rechazar Oferta</button>
  </div>
  </div>
  